import type { HeartRateEvent } from '@model/DeviceConfiguration';
import { buildSessionValueMap } from './sessionTrack';
import type { TrendSignalKey } from '../types';
import { getTrendSignalValue } from './featureValue';

const cache = new Map<string, Map<number, number>>();

const buildCacheKey = (
  sessionId: number,
  events: HeartRateEvent[],
  feature: TrendSignalKey
) => {
  const lastTimestamp =
    events.length > 0 ? (events[events.length - 1]?.timestamp ?? 0) : 0;

  return `${sessionId}:${events.length}:${lastTimestamp}:${feature}`;
};

export const getCachedSessionValueMap = (
  sessionId: number,
  events: HeartRateEvent[],
  feature: TrendSignalKey
): Map<number, number> => {
  const key = buildCacheKey(sessionId, events, feature);
  const cached = cache.get(key);
  if (cached) return cached;

  const next = buildSessionValueMap(events, event =>
    getTrendSignalValue(event, feature)
  );
  cache.set(key, next);
  return next;
};

export const clearSessionValueMapCache = () => {
  cache.clear();
};
